import http from "@http";
import toResponse from "@helpers/toResponse/toResponse";

export const reportCrashError = (values) =>
  toResponse(http.post("/error", values));
